import React from 'react';
import {
  Container,
  LegendItem,
  LegendIcon,
} from './AvailabilityDurationLegend.style';

import TickSvg from '../../static/images/icons/Tick.svg';
import { Text } from '../ui';
import { dictionaryItem } from '../../hocs/withDictionary';

const AvailabilityDurationLegend = () => (
  <Container>
    <LegendItem>
      <LegendIcon icon={TickSvg} />
      <Text
        dictionary={dictionaryItem(
          'AvailabilityAmend',
          'CalendarLegend',
          'Tick',
        )}
      />
    </LegendItem>
  </Container>
);

export default AvailabilityDurationLegend;
